import { CrossSell } from './cross_sell';

export default CrossSell;
